import { createLaboratorioAnaliseApi } from "@/contexts/laboratorio/laboratorioAnalise/api/laboratorioAnaliseApi";
import { LaboratorioAnalise } from "@/contexts/laboratorio/laboratorioAnalise/model/LaboratorioAnalise";
import {
  getLaboratorioSynced,
  laboratorioAction,
} from "@/contexts/laboratorio/laboratorioAnalise/store/laboratorioAnaliseSlice";
import { useAuth } from "react-oidc-context";
import { useDispatch, useSelector } from "react-redux";

export const useLaboratorioAnalise = () => {
  const { user } = useAuth();
  const laboratorioAnaliseApi = createLaboratorioAnaliseApi(user?.access_token);
  const listaLaboratorios = useSelector(getLaboratorioSynced);
  const appDispatch = useDispatch();
  const { sync } = laboratorioAction;
  const laboratoriosOptions = listaLaboratorios.map((lab) => ({
    label: lab.nome,
    value: lab.id,
  }));

  const sincronizarLaboratorios = (estabelecimentos: LaboratorioAnalise[]) => {
    appDispatch(sync(estabelecimentos));
  };

  const getLaboratoriosApi = laboratorioAnaliseApi.listAll;

  const getLaboratorioById = (id: number) => {
    return listaLaboratorios.find((laboratorio) => laboratorio.id === id);
  };

  return {
    getLaboratoriosApi,
    listaLaboratorios,
    sincronizarLaboratorios,
    laboratoriosOptions,
    getLaboratorioById,
  };
};
